"use client";

import "@kalkulacka-one/design-system/themes/www.volebnikalkulacka.cz/prima.css";

export const PrimaTheme = ({ children }: { children: React.ReactNode }) => {
  return children;
};
